module.exports = __webpack_public_path__ + "img/6.3a85a0c6.jpg";